
export class NewPostControlDocumentDto {
    postControlInfo;
    postControlNote;

}


















